import { UserAttribute } from './userattribute';
import { SkillType } from './skilltype';
import { DocumentResponse } from './documentresponse';


export class UserAttrSkillWrapper {
    public userAttribute: UserAttribute = new UserAttribute();
    public skillTypeList: SkillType[] = [];
    public documentResponse  : DocumentResponse | null = new DocumentResponse();
	public documentList  : DocumentResponse[] = [];
}